// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colors */
/* Layout tokens */
/* Export CSS variables */
:root {
  --page-bg: #f6f7f9;
  --panel-bg: #ffffff;
  --muted: #6b7280;
  --text: #0f1724;
  --accent-green: #2ea44f;
  --accent-yellow: #ffb020;
  --accent-orange: #ff7a00;
  --danger: #d9534f;
  --card-border: rgba(15, 23, 42, 0.06);
  --radius-lg: 10px;
  --radius-md: 8px;
  --shadow-soft: 0 10px 30px rgba(16, 24, 40, 0.06);
  --gutter: 24px;
  --max-width: 1180px;
  --font-stack: Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial;
}

.serviceAgreements_card__0-Xmg,
.serviceAgreements_tru-mma-main-content-box__OaYE- {
  overflow: visible !important;
}

.serviceAgreements_col-12__Ki0x\\+.serviceAgreements_d-flex__rANwd.serviceAgreements_pl-20__7YL0\\+.serviceAgreements_mb-20__EmL8h {
  display: flex !important;
  justify-content: center;
  align-items: center;
  padding-left: 0 !important;
  margin-top: 12px;
  margin-bottom: 20px;
}

.serviceAgreements_enrollBtn__m96Fv {
  background: #ff7a00;
  color: #ffffff;
  border-radius: 8px;
  padding: 10px 18px;
  margin-top: 10px;
  font-weight: 700;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: none !important;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.serviceAgreements_enrollBtn__m96Fv:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 14px 36px rgba(255, 176, 32, 0.18);
}

.serviceAgreements_enrollBtn__m96Fv:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.serviceAgreements_enrollBtn__m96Fv,
.serviceAgreements_enrollBtn__m96Fv:disabled {
  visibility: visible !important;
  opacity: 1 !important;
}

@media (max-width: 640px) {
  .serviceAgreements_enrollBtn__m96Fv {
    width: 100%;
    min-width: 0;
    padding: 12px 16px;
    font-size: 15px;
  }
  .serviceAgreements_col-12__Ki0x\\+.serviceAgreements_d-flex__rANwd.serviceAgreements_pl-20__7YL0\\+.serviceAgreements_mb-20__EmL8h {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
}
.serviceAgreements_footerCta__54eGy {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
}

.serviceAgreements_footerCta__54eGy {
  border: 2px solid red;
}

.serviceAgreements_tru-mma-main-add__Hg6up, .serviceAgreements_tru-mma-main-content-box__OaYE-, .serviceAgreements_tru-mma-main-service-box__yDhcy {
  border: 1px solid #6c757d;
}

.serviceAgreements_mb-16__iNTOd {
  margin-bottom: 16px !important;
}

.serviceAgreements_bg-white__o-ZOv {
  color: #666;
}

.serviceAgreements_bg-white__o-ZOv {
  background-color: #fff !important;
}

.serviceAgreements_mt-10__qOTOb {
  margin-top: 10px !important;
}

.serviceAgreements_p-10__aP0CG {
  padding: 10px !important;
}

.serviceAgreements_mb-10__EXLnm {
  margin-bottom: 10px !important;
}

.serviceAgreements_g-font-size-20__8BHwh, .serviceAgreements_gfs-20__riB1W {
  font-size: 20px !important;
}

.serviceAgreements_g-font-weight-300__wBpHL, .serviceAgreements_gfw-3__zuAYV {
  font-weight: 300 !important;
}

.serviceAgreements_pl-20__7YL0\\+, .serviceAgreements_px-20__OGFVL {
  padding-left: 20px !important;
}

.serviceAgreements_g-font-weight-400__P5r2h, .serviceAgreements_gfw-4__hocE3 {
  font-weight: 400 !important;
}

.serviceAgreements_btn-lg__IOZpD {
  min-width: 160px !important;
  border-radius: 0px !important;
}

.serviceAgreements_btn__-ZoQI {
  line-height: 1.3em !important;
  white-space: unset;
}

.serviceAgreements_text-white__xH6o7 {
  color: #fff !important;
}

.serviceAgreements_bg-yellow__dlBSb {
  background-color: #ffb034 !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/_easyPayTokens.scss","webpack://./src/styles/serviceAgreements.module.scss"],"names":[],"mappings":"AAGA,WAAA;AAaA,kBAAA;AAQA,yBAAA;AACA;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,wBAAA;EACA,wBAAA;EACA,iBAAA;EACA,qCAAA;EACA,iBAAA;EACA,gBAAA;EACA,iDAAA;EACA,cAAA;EACA,mBAAA;EACA,sFAAA;ACrBJ;;AAjBA;;EAEE,4BAAA;AAoBF;;AAjBA;EACE,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;AAoBF;;AAjBA;EACE,mBDLc;ECMd,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EAEA,2BAAA;EACA,wCAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;AAmBF;;AAhBA;EACE,2BAAA;EACA,gDAAA;AAmBF;;AAhBA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAmBF;;AAhBA;;EAEE,8BAAA;EACA,qBAAA;AAmBF;;AAhBA;EACE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;EAmBF;EAhBA;IACE,6BAAA;IACA,8BAAA;EAkBF;AACF;AAfA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAiBF;;AAdA;EACE,qBAAA;AAiBF;;AAdC;EACG,yBAAA;AAiBJ;;AAfA;EACI,8BAAA;AAkBJ;;AAhBA;EACI,WAAA;AAmBJ;;AAjBA;EACI,iCAAA;AAoBJ;;AAlBA;EACI,2BAAA;AAqBJ;;AAlBA;EACI,wBAAA;AAqBJ;;AAnBA;EACI,8BAAA;AAsBJ;;AApBA;EACI,0BAAA;AAuBJ;;AApBA;EACI,2BAAA;AAuBJ;;AArBA;EACI,6BAAA;AAwBJ;;AAtBA;EACI,2BAAA;AAyBJ;;AAvBA;EACI,2BAAA;EACA,6BAAA;AA0BJ;;AAxBA;EACI,6BAAA;EACA,kBAAA;AA2BJ;;AAzBA;EACI,sBAAA;AA4BJ;;AA1BA;EACI,oCAAA;AA6BJ","sourcesContent":["// styles/_easyPayTokens.scss\n$font-stack: \"Inter\", system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial !default;\n\n/* Colors */\n$page-bg: #f6f7f9 !default;\n$panel-bg: #ffffff !default;\n$muted: #6b7280 !default;\n$text: #0f1724 !default;\n$accent-green: #2ea44f !default;\n$accent-green-600: #1f8a3a !default;\n$accent-yellow: #ffb020 !default;\n$accent-yellow-600: #e09b00 !default;\n$accent-orange: #ff7a00 !default;\n$danger: #d9534f !default;\n$card-border: rgba(15, 23, 42, 0.06) !default;\n\n/* Layout tokens */\n$radius-lg: 10px !default;\n$radius-md: 8px !default;\n$shadow-soft: 0 10px 30px rgba(16, 24, 40, 0.06) !default;\n$shadow-sm: 0 8px 24px rgba(16, 24, 40, 0.06) !default;\n$gutter: 24px !default;\n$max-width: 1180px !default;\n\n/* Export CSS variables */\n:root {\n    --page-bg: #{$page-bg};\n    --panel-bg: #{$panel-bg};\n    --muted: #{$muted};\n    --text: #{$text};\n    --accent-green: #{$accent-green};\n    --accent-yellow: #{$accent-yellow};\n    --accent-orange: #{$accent-orange};\n    --danger: #{$danger};\n    --card-border: #{$card-border};\n    --radius-lg: #{$radius-lg};\n    --radius-md: #{$radius-md};\n    --shadow-soft: #{$shadow-soft};\n    --gutter: #{$gutter};\n    --max-width: #{$max-width};\n    --font-stack: #{$font-stack};\n}","@use \"./_easyPayTokens\" as tokens;\n\n.card,\n.tru-mma-main-content-box {\n  overflow: visible !important;\n}\n\n.col-12.d-flex.pl-20.mb-20 {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  padding-left: 0 !important;\n  margin-top: 12px;\n  margin-bottom: 20px;\n}\n\n.enrollBtn {\n  background: tokens.$accent-orange; \n  color: #ffffff;\n  border-radius: 8px;\n  padding: 10px 18px;\n  margin-top: 10px;\n  font-weight: 700;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n\n  transition: none !important;\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n  cursor: pointer;\n}\n\n.enrollBtn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 36px rgba(255, 176, 32, 0.18);\n}\n\n.enrollBtn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n.enrollBtn,\n.enrollBtn:disabled {\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n@media (max-width: 640px) {\n  .enrollBtn {\n    width: 100%;\n    min-width: 0;\n    padding: 12px 16px;\n    font-size: 15px;\n  }\n\n  .col-12.d-flex.pl-20.mb-20 {\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n  }\n}\n\n.footerCta {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 12px 0;\n}\n\n.footerCta {\n  border: 2px solid red;\n}\n\n .tru-mma-main-add,  .tru-mma-main-content-box,  .tru-mma-main-service-box {\n    border: 1px solid #6c757d;\n}\n.mb-16 {\n    margin-bottom: 16px !important;\n}\n.bg-white {\n    color: #666;\n}\n.bg-white {\n    background-color: #fff !important;\n}\n.mt-10 {\n    margin-top: 10px !important;\n}\n\n.p-10 {\n    padding: 10px !important;\n}\n.mb-10 {\n    margin-bottom: 10px !important;\n}\n.g-font-size-20, .gfs-20 {\n    font-size: 20px !important;\n}\n\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.pl-20, .px-20 {\n    padding-left: 20px !important;\n}\n.g-font-weight-400, .gfw-4 {\n    font-weight: 400 !important;\n}\n.btn-lg {\n    min-width: 160px !important;\n    border-radius: 0px !important;\n}\n.btn {\n    line-height: 1.3em !important;\n    white-space: unset;\n}\n.text-white {\n    color: #fff !important;\n}\n.bg-yellow {\n    background-color: #ffb034 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `serviceAgreements_card__0-Xmg`,
	"tru-mma-main-content-box": `serviceAgreements_tru-mma-main-content-box__OaYE-`,
	"col-12": `serviceAgreements_col-12__Ki0x+`,
	"d-flex": `serviceAgreements_d-flex__rANwd`,
	"pl-20": `serviceAgreements_pl-20__7YL0+`,
	"mb-20": `serviceAgreements_mb-20__EmL8h`,
	"enrollBtn": `serviceAgreements_enrollBtn__m96Fv`,
	"footerCta": `serviceAgreements_footerCta__54eGy`,
	"tru-mma-main-add": `serviceAgreements_tru-mma-main-add__Hg6up`,
	"tru-mma-main-service-box": `serviceAgreements_tru-mma-main-service-box__yDhcy`,
	"mb-16": `serviceAgreements_mb-16__iNTOd`,
	"bg-white": `serviceAgreements_bg-white__o-ZOv`,
	"mt-10": `serviceAgreements_mt-10__qOTOb`,
	"p-10": `serviceAgreements_p-10__aP0CG`,
	"mb-10": `serviceAgreements_mb-10__EXLnm`,
	"g-font-size-20": `serviceAgreements_g-font-size-20__8BHwh`,
	"gfs-20": `serviceAgreements_gfs-20__riB1W`,
	"g-font-weight-300": `serviceAgreements_g-font-weight-300__wBpHL`,
	"gfw-3": `serviceAgreements_gfw-3__zuAYV`,
	"px-20": `serviceAgreements_px-20__OGFVL`,
	"g-font-weight-400": `serviceAgreements_g-font-weight-400__P5r2h`,
	"gfw-4": `serviceAgreements_gfw-4__hocE3`,
	"btn-lg": `serviceAgreements_btn-lg__IOZpD`,
	"btn": `serviceAgreements_btn__-ZoQI`,
	"text-white": `serviceAgreements_text-white__xH6o7`,
	"bg-yellow": `serviceAgreements_bg-yellow__dlBSb`
};
export default ___CSS_LOADER_EXPORT___;
